import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const PARTICLE_COLORS = ['var(--green)', '#7fe87f', 'var(--yellow)', '#a8e6a1'];

function Particle({ color, angle, delay }) {
  const rad = (angle * Math.PI) / 180;
  const dist = 30 + Math.random() * 20;
  return (
    <motion.div
      initial={{ opacity: 1, x: 0, y: 0, scale: 1 }}
      animate={{ opacity: 0, x: Math.cos(rad) * dist, y: Math.sin(rad) * dist, scale: 0 }}
      transition={{ duration: 0.8, delay, ease: 'easeOut' }}
      style={{
        position: 'absolute',
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: color,
        boxShadow: `0 0 4px ${color}`,
      }}
    />
  );
}

export function HarvestCelebration({ notifications }) {
  const [bursts, setBursts] = useState([]);

  useEffect(() => {
    const latest = notifications[notifications.length - 1];
    if (!latest || latest.read) return;
    if (latest.message?.includes('Harvest') || latest.message?.includes('harvest')) {
      const id = latest.id;
      setBursts(prev => [...prev.slice(-2), { id, ts: Date.now() }]);
      setTimeout(() => setBursts(prev => prev.filter(b => b.id !== id)), 1200);
    }
  }, [notifications.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ position: 'fixed', top: '50%', left: '50%', pointerEvents: 'none', zIndex: 600 }}>
      <AnimatePresence>
        {bursts.map(b => (
          <div key={b.id} style={{ position: 'relative' }}>
            {Array.from({ length: 8 }).map((_, i) => (
              <Particle
                key={i}
                color={PARTICLE_COLORS[i % PARTICLE_COLORS.length]}
                angle={(360 / 8) * i}
                delay={i * 0.03}
              />
            ))}
          </div>
        ))}
      </AnimatePresence>
    </div>
  );
}
